import type { SideNav } from '@helm/types/sideNav'
import { HelmPermission } from '@helm/services/api/client'

const SIDE_NAV: SideNav = {
    organizations: [
        {
            label: `Organizations`,
            icon: `PhHouse`,
            route: `/organizations`,
            name: `organizations`
        },
        {
            label: `Cancellation Feedback`,
            icon: `PhX`,
            route: `/organizations/cancellation-feedback`,
            name: `organizations.cancellation-feedback`
        }
    ],
    organization: [
        {
            label: `Overview`,
            icon: `chart-bar`,
            route: {
                path: `/organizations/:id`,
                name: `organization`,
                params: { id: `:id` }
            }
        },
        {
            label: `Users`,
            icon: `user`,
            route: {
                path: `/organizations/:id/users`,
                name: `organization.users`,
                params: { id: `:id` }
            },
            roles: [HelmPermission.HELM_ORGANIZATION_WRITE]
        },
        {
            label: `Features & Integrations`,
            icon: `check`,
            route: {
                path: `/organizations/:id/features`,
                name: `organization.features`,
                params: { id: `:id` }
            },
            roles: [HelmPermission.HELM_FEATURE_READ]
        },
        {
            label: `Giving`,
            icon: `gift`,
            route: {
                path: `/organizations/:id/giving`,
                name: `organization.giving`,
                params: { id: `:id` }
            }
        },
        {
            label: `MDS`,
            icon: `users`,
            route: {
                path: `/organizations/:id/mds`,
                name: `organization.mds`,
                params: { id: `:id` }
            },
            roles: [HelmPermission.HELM_ORGANIZATION_WRITE]
        },
        {
            label: `Messaging`,
            icon: `PhChatCenteredText`,
            route: {
                path: `/organizations/:id/messaging`,
                name: `organization.messaging`,
                params: { id: `:id` }
            },
            roles: [HelmPermission.HELM_SMS_SETTINGS, HelmPermission.HELM_EMAIL_SETTINGS]
        }
    ],
    config: [
        {
            label: `App Config`,
            icon: `check`,
            route: `/config/app`,
            roles: [HelmPermission.HELM_CONFIG]
        },
        {
            label: `Service Plan Templates`,
            route: `/config/service-plan-templates`,
            icon: `plan`
        },
        {
            label: `Integrations`,
            route: '/config/integrations',
            name: 'config.integrations',
            icon: `extensions`
        },
        {
            label: `Retryable Jobs`,
            route: '/config/retryable-jobs',
            name: 'config.retryable-jobs',
            icon: `PhRepeat`
        },
        {
            label: `Feature Flags`,
            route: '/config/feature-flags',
            name: 'config.feature-flags',
            icon: `PhListChecks`,
            roles: [HelmPermission.HELM_FEATURE_DELETE]
        },
        {
            label: `IP Allowlist`,
            route: `/config/ip-allowlist`,
            name: `config.ip-allowlist`,
            icon: `PhShieldCheck`,
            roles: [HelmPermission.HELM_IP_ALLOWLIST_READ, HelmPermission.HELM_IP_ALLOWLIST_WRITE]
        },
        {
            label: `Navigation Callbacks`,
            route: '/config/nav-table',
            name: 'config.navigation-callbacks',
            icon: `PhNavigationArrow`,
            roles: [HelmPermission.HELM_NAVIGATION]
        }
    ],
    messaging: [
        {
            label: `Messaging Metrics`,
            route: `/messaging`,
            icon: `chart-bar`
        },
        {
            label: `Public Templates`,
            route: `/messaging/public-templates`,
            icon: `message`
        },
        {
            label: `Global Templates`,
            route: `/messaging/global-templates`,
            icon: `notification`
        },
        {
            label: `Email Suppressions`,
            route: `/messaging/email-suppressions`,
            name: `messaging.email-suppressions`,
            icon: `PhEnvelopeOpen`,
            roles: [HelmPermission.HELM_EMAIL_SUPPRESSION_READ, HelmPermission.HELM_EMAIL_SUPPRESSION_WRITE]
        },
        {
            label: `SMS Blacklist`,
            route: `/messaging/sms-blacklist`,
            name: `messaging.sms-blacklist`,
            icon: `PhPhoneSlash`,
            roles: [HelmPermission.HELM_SMS_BLACKLIST_READ, HelmPermission.HELM_SMS_BLACKLIST_WRITE]
        }
    ],
    users: [
        {
            label: `Users`,
            icon: `PhUsers`,
            route: `/users`,
            name: `users`,
            roles: [HelmPermission.HELM_USER_READ]
        },
        {
            label: `Roles`,
            icon: `PhLock`,
            route: `/roles`,
            name: `users.roles`,
            roles: [HelmPermission.HELM_USER_READ, HelmPermission.HELM_USER_WRITE]
        },
        {
            label: `SAML Login`,
            route: '/sso',
            name: 'config.sso',
            icon: `PhGoogleLogo`,
            roles: [HelmPermission.HELM_CONFIG, HelmPermission.HELM_USER_WRITE]
        }
    ]
}

export default SIDE_NAV
